import { render, staticRenderFns } from "./SeoOrders.vue?vue&type=template&id=63ebd70b&"
import script from "./SeoOrders.vue?vue&type=script&lang=js&"
export * from "./SeoOrders.vue?vue&type=script&lang=js&"
import style0 from "./SeoOrders.vue?vue&type=style&index=0&id=63ebd70b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports